<div *ngIf="!config?.header_type" class="head-note-section">
  <div class="note" [ngClass]="{'justify-content-center': config?.v1 && !isMobile}">
    <img src="/assets/images/success-tick.png" alt="success-tick">
    <div class="text">
      <div class="heading">Donation Successful</div>
      <div class="desc">Thank you {{config?.user?.full_name.trim()}} for donating <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local}}
        <span *ngIf="config?.order?.tip_amount_local"> + <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local}} (tip)</span>
      </div>
    </div>
  </div>
</div>


<div *ngIf="config?.header_type?.toString()?.match('v2')" class="head-section">
  <div class="note">
    <img src="/assets/images/success-tick-1.png" alt="success-tick">
    <div class="text" *ngIf="!config?.order?.bulkdonation">
      <div class="heading"><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.total_amount_charged | inrFormat:config?.order?.iso_currency}} donated successfully!</div>
      <div class="desc">Thank you for donating <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local | inrFormat:config?.order?.iso_currency}} <span *ngIf="config?.order?.tip_amount_local"> + <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}} Tip.</span></strong></div>
      <div class="desc">Keep supporting <strong>{{config?.order?.campaign?.beneficiaryname?.info_1.trim()}}.</strong></div>
    </div>
    <div class="text" *ngIf="config?.order?.bulkdonation">
      <div class="heading"><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.total_amount_charged | inrFormat:config?.order?.iso_currency}} donated successfully!</div>
      <div class="desc">Thank you for donating
        <strong>
          <div *ngFor="let item of config?.order?.bulkdonation; let i = index">
            <strong>
              <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{item?.amount | inrFormat:config?.order?.iso_currency}} to {{item?.campaign?.beneficiaryname?.info_1.trim()}}{{i === config?.order?.bulkdonation?.length - 1 ? '.': ','}}
            </strong>
          </div>
        </strong>
      </div>
      <div class="desc">Keep supporting them</div>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v3')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <div class="part-1">
      <div class="heading">Donation Successful!</div>
      <div class="desc">We have recieved your generous donation of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local | inrFormat:config?.order?.iso_currency}}</strong><span *ngIf="config?.order?.tip_amount_local"> and a tip of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}}</strong></span></div>
    </div>
    <div class="part-2">
      <mat-icon>check_circle</mat-icon>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v4')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <img src="../assets/images/donation-confirmation-img.png" alt="">
    <div class="part-2">
      <div class="name">Thank you {{config?.user?.full_name}} !</div>
      <div class="sub">This generous tip of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}}</strong> will help us to keep making the world better</div>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v5')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <div class="circle">
      <div class="title">{{config?.userIntials}}</div>
      <img src="../assets/images/heartfilled.png" alt="">
    </div>
    <div class="sub">Hi {{config?.user?.full_name}}!</div>
  </div>
</div>
